import { Button, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { orderColumns } from '../../../utils/Constant';
import { calculateTotal } from '../../../utils/helpers';
import Paragraph from 'antd/es/typography/Paragraph';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  addCoupon,
  checkCouponValidity,
  clearRazorpayItems,
  removeCoupon,
} from '../../../Redux/slices/cartSlice';
import { useMediaQuery } from 'react-responsive';
import CouponDialog from './CouponDialog';
import { useParams } from 'react-router-dom';

const Summary = ({ checkedItems, tableData, onValidateCoupon }) => {
  const dispatch = useDispatch();
  const [code, setCode] = useState('');

  const { couponId, couponCode } = useSelector((state) => state.cart);
  const { id } = useParams();
  const [openCouponDialog, setOpenCouponDialog] = useState(false);
  Summary.propTypes = {
    checkedItems: PropTypes.array,
    tableData: PropTypes.array,
  };
  useEffect(() => {
    setCode(couponCode);
  }, [couponCode]);
  const handleRemoveCoupon = () => {
    setCode('');
    dispatch(removeCoupon());
  };

  const isMobile = useMediaQuery({ maxWidth: 600 });
  const handleApply = () => {
    console.log('code', code);
    // if (code) {
    dispatch(
      checkCouponValidity({
        params: { eventId: id, amount: calculateTotal(tableData) },
        code,
      })
    );
    // dispatch(addCoupon(selectedCoupon));
    // } else setOpenCouponDialog(true);
  };
  return (
    <div>
      {' '}
      {checkedItems.length > 0 && (
        <>
          <div className="order-summary-container square-container border-radius-14">
            <div className="square-heading" style={{ marginBottom: 16 }}>
              Offers & Benefits
            </div>
            <div className="coupon-container">
              {/* <span
                className={
                  couponCode ? "choose-coupon-text" : "choose-coupon-heading"
                }
              >
                {couponCode ? couponCode : "Choose any applicable coupon"}
              </span> */}
              <input
                className="choose-coupon-text"
                onChange={(e) => setCode(e.target.value)}
                style={{
                  width: '100%',
                  border: '0px solid #000',
                  outline: 'none',
                }}
                value={code}
                placeholder="Enter Coupon Code"
              />
              <Button
                type="text"
                className="apply-coupon-btn"
                variant="primary"
                onClick={
                  () => (couponId ? handleRemoveCoupon() : handleApply())
                  // couponApplied
                  //   ? dispatch(clearRazorpayItems())
                  //   : onValidateCoupon(code)
                }
              >
                {couponId ? 'REMOVE COUPON' : 'APPLY COUPON'}
              </Button>
            </div>
          </div>
          <div className="order-summary-container square-container border-radius-14">
            <div className="square-heading" style={{ marginBottom: 16 }}>
              Order Summary
            </div>
            <Table
              className="order-summary-table"
              dataSource={tableData}
              columns={orderColumns}
              pagination={{
                position: ['none', 'none'],
              }}
            />
            <div className="total-amount-container">
              <div className="total-payable-amount-text">
                Total Payable Amount
              </div>
              <div className="total-payable-amount">
                ₹{calculateTotal(tableData)}
              </div>
            </div>
          </div>
        </>
      )}
      <CouponDialog
        open={openCouponDialog}
        handleClose={() => setOpenCouponDialog(false)}
        total={calculateTotal(tableData)}
      />
    </div>
  );
};

export default Summary;
